import { render, staticRenderFns } from "./MovieMediaTab.vue?vue&type=template&id=596b4f71&scoped=true&"
import script from "./MovieMediaTab.vue?vue&type=script&lang=js&"
export * from "./MovieMediaTab.vue?vue&type=script&lang=js&"
import style0 from "./MovieMediaTab.vue?vue&type=style&index=0&id=596b4f71&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "596b4f71",
  null
  
)

export default component.exports